import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from "../components/ui/command";
import { DialogTitle, DialogDescription } from "../components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import {
  LayoutDashboard, Building2, PenSquare, Compass, Calendar, CreditCard,
  Settings, LogOut, Sparkles, Mail,
} from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function CommandPalette() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault(); setOpen(o => !o);
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  const go = (path) => () => { setOpen(false); nav(path); };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <VisuallyHidden>
        <DialogTitle>Palette de commandes</DialogTitle>
        <DialogDescription>Naviguez rapidement dans Local Pulse</DialogDescription>
      </VisuallyHidden>
      <CommandInput placeholder="Tapez une commande ou recherchez…" data-testid="command-input" />
      <CommandList>
        <CommandEmpty>Aucun résultat.</CommandEmpty>
        <CommandGroup heading="Navigation">
          <CommandItem onSelect={go("/dashboard")}><LayoutDashboard className="mr-2 h-4 w-4" />Vue d'ensemble</CommandItem>
          <CommandItem onSelect={go("/dashboard/profile")}><Building2 className="mr-2 h-4 w-4" />Profil business</CommandItem>
          <CommandItem onSelect={go("/dashboard/generator")}><PenSquare className="mr-2 h-4 w-4" />Studio de contenu</CommandItem>
          <CommandItem onSelect={go("/dashboard/audit")}><Compass className="mr-2 h-4 w-4" />Audit de visibilité</CommandItem>
          <CommandItem onSelect={go("/dashboard/calendar")}><Calendar className="mr-2 h-4 w-4" />Calendrier</CommandItem>
        </CommandGroup>
        <CommandGroup heading="Compte">
          <CommandItem onSelect={go("/dashboard/pricing")}><CreditCard className="mr-2 h-4 w-4" />Abonnement</CommandItem>
          <CommandItem onSelect={go("/dashboard/settings")}><Settings className="mr-2 h-4 w-4" />Paramètres</CommandItem>
          <CommandItem onSelect={() => { setOpen(false); window.location.href = "/contact"; }}><Mail className="mr-2 h-4 w-4" />Contacter le support</CommandItem>
        </CommandGroup>
        <CommandGroup heading="Actions rapides">
          <CommandItem onSelect={go("/dashboard/generator")}><Sparkles className="mr-2 h-4 w-4" />Rédiger un nouveau contenu</CommandItem>
          <CommandItem onSelect={async () => { setOpen(false); await logout(); nav("/"); }}><LogOut className="mr-2 h-4 w-4" />Déconnexion</CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
